import { render } from "./PromocionesList.vue?vue&type=template&id=8929a62e"
import script from "./PromocionesList.vue?vue&type=script&lang=js"
export * from "./PromocionesList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__